import React from "react";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";
import { TotalesMensualRow } from "./TotalesMensualRow";

export const ListadoMensualTable = ({
    traslados = [],
    totalesTraslados = {},
}) => {
    if (!traslados.length) {
        return (
            <div className="text-center py-5">
                <h3>No hay datos disponibles</h3>
            </div>
        );
    }

    return (
        <div className="new-table-wrapper reporte-traslados__table-wrapper sticky-header sticky-first-column">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2} className="cell-border-right">
                            MES
                        </th>
                        <th colSpan={5} className="cell-border-right">
                            INGRESO
                        </th>
                        <th colSpan={3} className="cell-border-right">
                            ERSA
                        </th>
                        <th colSpan={2} className="cell-border-right">
                            LIQUIDACIÓN
                        </th>
                        <th colSpan={2} className="cell-border-right">
                            DIFERENCIA ERSA
                        </th>
                        <th colSpan={2} className="cell-border-right">
                            VARIACIÓN ERSA
                        </th>
                        <th
                            rowSpan={2}
                            className="reporte-traslados__min-width-cell cell-border-right"
                        >
                            VARIACIÓN PRODUCCIÓN
                        </th>
                        <th rowSpan={2}>PÉRDIDA DE AGUA</th>
                    </tr>
                    <tr>
                        {/* INGRESO */}
                        <th>KG INGRESO ACOPIO</th>
                        <th>KG SECOS LAB</th>
                        <th className="reporte-traslados__min-width-cell">
                            DRC REAL INGRESO ACOPIO
                        </th>
                        <th className="reporte-traslados__min-width-cell">
                            KG HUM SALIDA ACOPIO
                        </th>
                        <th className="cell-border-right">
                            DIFERENCIA SALIDA ACOPIO/ERSA
                        </th>

                        {/* ERSA */}
                        <th>KG HUM INGRESO ERSA</th>
                        <th className="reporte-traslados__min-width-cell">
                            KG SECOS INGRESO ERSA
                        </th>
                        <th className="cell-border-right">DRC INGRESO</th>

                        {/* LIQUIDACIÓN */}
                        <th>KG SECOS LIQUIDADOS</th>
                        <th className="cell-border-right">
                            DRC REAL LIQUIDACIÓN
                        </th>

                        {/* DIFERENCIA ERSA */}
                        <th className="reporte-traslados__min-width-cell">
                            DIFERENCIA LABORATORIO ACOPIO
                        </th>
                        <th className="reporte-traslados__min-width-cell cell-border-right">
                            DIFERENCIA LIQUIDACIÓN ERSA
                        </th>
                        {/* VARIACIÓN ERSA */}
                        <th>LABORATORIO ACOPIO</th>
                        <th className="cell-border-right">LIQUIDACIÓN ERSA</th>
                    </tr>
                </thead>
                <tbody>
                    {traslados.map((item, index) => {
                        return (
                            <tr key={item.mes || index}>
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.mes}
                                </td>
                                {/* INGRESO */}
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.acopio_kg_humedo}
                                    >
                                        <RenderKilogramo
                                            value={item.acopio_kg_humedo}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.acopio_kg_seco_lab}
                                    >
                                        <RenderKilogramo
                                            value={item.acopio_kg_seco_lab}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.acopio_drc_lab ? (
                                        <RenderNumberPercentage
                                            value={item.acopio_drc_lab}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.acopio_kg_hum_salida}
                                    >
                                        <RenderKilogramo
                                            value={item.acopio_kg_hum_salida}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <NullableValue
                                        value={item.diferencia_hum_transporte}
                                    >
                                        <RenderKilogramo
                                            value={
                                                item.diferencia_hum_transporte
                                            }
                                        />
                                    </NullableValue>
                                </td>
                                {/* ERSA */}
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.planta_kg_humedo}
                                    >
                                        <RenderKilogramo
                                            value={item.planta_kg_humedo}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.planta_kg_seco_lab}
                                    >
                                        <RenderKilogramo
                                            value={item.planta_kg_seco_lab}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.planta_drc_lab ? (
                                        <RenderNumberPercentage
                                            value={item.planta_drc_lab}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                {/* LIQUIDACIÓN */}
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.liquidacion_kg_seco}
                                    >
                                        <RenderKilogramo
                                            value={item.liquidacion_kg_seco}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.liquidacion_drc_real ? (
                                        <RenderNumberPercentage
                                            value={item.liquidacion_drc_real}
                                        />
                                    ) : (
                                        "—"
                                    )}
                                </td>
                                {/* DIFERENCIA ERSA */}
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.diferencia_acopio_lab}
                                    >
                                        <RenderKilogramo
                                            value={item.diferencia_acopio_lab}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <NullableValue
                                        value={item.diferencia_liquidado}
                                    >
                                        <RenderKilogramo
                                            value={item.diferencia_liquidado}
                                        />
                                    </NullableValue>
                                </td>
                                {/* VARIACIÓN ERSA */}
                                <td className="text-center text-nowrap text-right">
                                    <NullableValue
                                        value={item.variacion_acopio_lab}
                                    >
                                        <RenderNumberPercentage
                                            value={item.variacion_acopio_lab}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap text-right cell-border-right">
                                    <NullableValue
                                        value={item.variacion_liquidado}
                                    >
                                        <RenderNumberPercentage
                                            value={item.variacion_liquidado}
                                        />
                                    </NullableValue>
                                </td>
                                {/* VARIACIÓN PRODUCCIÓN */}
                                <td
                                    className="text-center text-nowrap text-right cell-border-right"
                                    title={
                                        item.variacion_produccion_detalle || ""
                                    }
                                >
                                    <NullableValue
                                        value={item.variacion_produccion}
                                    >
                                        <RenderNumberPercentage
                                            value={item.variacion_produccion}
                                        />
                                    </NullableValue>
                                </td>
                                {/* PÉRDIDA DE AGUA */}
                                <td className="text-center text-nowrap text-right">
                                    <NullableValue value={item.perdida_agua}>
                                        <RenderNumberPercentage
                                            value={item.perdida_agua}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                    <TotalesMensualRow totalesTraslados={totalesTraslados} />
                </tbody>
            </table>
        </div>
    );
};
